import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionRequestSceneSwap } from "../scenes/actionScenes";
import { IdScene } from "../scenes/types/IdScene";
import { TypeActionApp } from "./actionApp";
export var epicApp = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionApp.Init), switchMap(function () {
        return of(actionRequestSceneSwap(IdScene.PlayerBase));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/app/epicApp.ts
// module id = 1770
// module chunks = 3